export const DEV = 'dev';
export const QA = 'qa';
export const PREPROD = 'preprod';
export const TESTNET = 'testnet';
export const PRODUCTION = 'production';

export const SETTING_KEYS = {
  LANGUAGE: 'language',
  CURRENCY: 'nativeCurrency',
};

export const AUTH_TYPE = {
  BOTH: 'both',
  GOOGLE: 'google',
  SMS: 'sms',
};

export const TOAST_FADE_TIME = 5;
